import Vue from 'vue'

export default {

    /**
     * Add request to the log
     * @param state
     * @param count
     * @constructor
     */
    ADD_AJAX_REQUEST(state, count) {

        // Incease requests count
        Vue.set(state, 'ajaxRequestsCount', state.ajaxRequestsCount + count);

    },

    /**
     * Set varable
     * @param state
     * @param payload
     * @constructor
     */
    SET_VARIABLE(state, payload) {

        // Incease requests count
        Vue.set(state.vars, payload.var, payload.val);

    },

    /**
     * Set last update time
     * @param state
     * @param tm
     * @constructor
     */
    SET_LAST_UPDATE_TIME(state, tm)
    {
        // Set value
        state.lastUpdateTime = tm
    }
}
